let pendingRequests = 0;
const listeners = new Set();

const notify = () => {
  const isLoading = pendingRequests > 0;
  listeners.forEach((listener) => listener(isLoading));
};

export const showLoading = () => {
  pendingRequests += 1;
  notify();
};

export const hideLoading = () => {
  pendingRequests = Math.max(0, pendingRequests - 1);
  notify();
};

export const subscribeLoading = (listener) => {
  listeners.add(listener);
  listener(pendingRequests > 0);
  return () => listeners.delete(listener);
};
